module.exports = __webpack_public_path__ + "94a912bd49462cbc7de707b9fd671ce0.svg";